import React, { useState } from 'react'
import { s3Static } from '../../../../utils/constants'
import Image from 'next/image'
import { RequestProvider } from '../../../../context/RequestContext'
import { useRouter } from 'next/router'
import { LoadingCover } from '../../../commons/LoadingCover'
import Link from 'next/link'
import { Faq } from '../../../commons/Faq'
import { acSingaporeFaqs } from '../../../../utils/faq'
import { AnimatePresence, motion } from 'framer-motion'
import { SystemError } from '../../../error/SystemError'
import { AirconScope } from './AirconScope'
import dynamic from 'next/dynamic'
// Heavy, below-the-fold / modal-only components: keep them out of the initial bundle.
const AirconDealItem = dynamic(() => import('./AirconDealItem').then(m => m.AirconDealItem), { ssr: true })
const AirconItemSelection = dynamic(() => import('./AirconItemSelection').then(m => m.AirconItemSelection), { ssr: false })
import { HowToBookAirconService } from './HowToBookAirconService'
import { AirconGeneralServiceProcess } from './AirconGeneralServiceProcess'
import { AirconCustomerReviews } from './AirconCustomerReviews'
import { AirconBrandsWeSupport } from './AirconBrandsWeSupport'
import { AirconServices } from './AirconServices'
import AirconRequestSection from './AirconRequestSection'
import { AirconWhyUs } from './AirconWhyUs'
import { AirconPriceComparison } from './AirconPriceComparison'
import { AirconServiceMatcher } from './AirconServiceMatcher'
import { AcServiceLocality } from './AcServiceLocality'
import { AirconGuides } from './AirconGuides'
import { countryList } from '../../../../utils/constants'
import { FaCheckCircle, FaGift, FaUsers, FaPercent, FaArrowRight } from 'react-icons/fa'
import { HiShieldCheck } from 'react-icons/hi2'

const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    visible: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.45, delay: i * 0.1, ease: 'easeOut' } }),
}

export const Aircon = (props) => {
    const requestCategorySettings = props.requestCategorySettings;
    const countryName = props.countryName
    const standardServicing = props.oneTimeServicing
    const chemicalServicing = props.chemicalServicing
    const overhaulServicing = props.overhaulServicing
    const currencyCd = props.currencyCd
    const year = props.year 
    const h1Tag = props.h1Tag
    const requestType = 'Aircon Services'

    const router = useRouter()  

    const [ requestForm, setRequestForm ] = useState(false)    
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ isCustomBook, setIsCustomBook ] = useState(false)
    const [ isShowJobScope, setIsShowJobScope ] = useState(false)
    const [ serviceType, setServiceType ] = useState("general")
    const [ unit, setUnit ] = useState("")
    const [ unitType, setUnitType ] = useState("")
    const [ cost, setCost ] = useState("")
    const [ isShowAirconItemSelection, setIsShowAirconItemSelection ] = useState(false)
    const [ selectedService, setSelectedService ] = useState("all")
    
    const [ isLoading, setIsLoading ] = useState(false)  
    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})

    const showJobScope = (serviceType, unitType, unit, cost) => {
        setServiceType(serviceType)
        setUnit(unit)
        setUnitType(unitType)
        setCost(cost)
        setIsShowJobScope(true)
    }
    
  return (
    <>
        <RequestProvider>
            <AirconRequestSection
                requestForm={requestForm}
                setRequestForm={setRequestForm}
                isQuickBook={isQuickBook}
                setIsQuickBook={setIsQuickBook}
                isCustomBook={isCustomBook}
                setIsCustomBook={setIsCustomBook}
                requestCategorySettings={requestCategorySettings}
                standardServicing={standardServicing}
                chemicalServicing={chemicalServicing}
                overhaulServicing={overhaulServicing}
                currencyCd={currencyCd}
                countryName={countryName}
                requestType={requestType}
                setIsShowJobScope={setIsShowJobScope}
                serviceType={serviceType}
                setServiceType={setServiceType}
                setUnit={setUnit}
                setUnitType={setUnitType}
                setCost={setCost}
                heroImage="blog/living/aircon/chinese-aircon-service-man-smiling.jpg"
                title="Aircon Servicing Singapore"
                subtitle="From $17/unit. Vetted technicians from licensed contractors, island-wide."
            />
            {isShowAirconItemSelection &&
                <AnimatePresence>
                    <AirconItemSelection setIsShowAirconItemSelection={setIsShowAirconItemSelection} setRequestForm={setRequestForm} setIsCustomBook={setIsCustomBook} setIsQuickBook={setIsQuickBook} userId={null}/>
                </AnimatePresence>
            }
            {/* ─── Price proof: substantiates the $17/unit claim ─── */}
            <AirconPriceComparison />

            {/* ─── Deals Section ─── */}
            <section className="relative py-12 md:py-16 overflow-hidden">
                <div className="max-w-5xl mx-auto px-4">
                    <div className="text-center mb-8">
                        <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 tracking-tight">
                            Aircon Service Deals — {year}
                        </h2>
                    </div>
                    <div className="md:space-y-5 pt-2 px-1">
                        <AirconDealItem
                            showJobScope={showJobScope}
                            setRequestForm={setRequestForm}
                            setIsQuickBook={setIsQuickBook}
                            setIsCustomBook={setIsCustomBook}
                            setIsShowAirconItemSelection={setIsShowAirconItemSelection}
                            selectedService={selectedService}
                        />
                    </div>
                </div>
            </section>
            {/* Intro prose merged into AirconPriceComparison - both sections covered
                price/affordability but were split by the deals block. */}
            <AirconCustomerReviews testimonials={props.testimonials} />
            <HowToBookAirconService />
            {/* Adds the 6-step "what you actually get" content the page was missing, and
                carries the LazyYouTubeEmbed for Pa5-iT9WkV8 - the exact video the page's
                VideoObject schema already described but never rendered. */}
            <section className='max-w-5xl mx-auto py-5 md:py-10'>
                <AirconGeneralServiceProcess />
            </section>
            <AirconServices />
            {/* AirconProblems removed: the matcher covers all 7 of its links and the
                same 6 faults, with a named cause and a recommended service per row. */}
            <AirconServiceMatcher />
            <AirconWhyUs />

            {/* ─── Discounts & Rewards ─── */}
            {/* <section className="relative py-8 md:py-14 overflow-hidden">
                <div className="max-w-5xl mx-auto px-4">
                    <div className="text-center mb-10">
                        <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 tracking-tight">
                            Discounts & Rewards
                        </h2>
                    </div>
                    <div className="grid md:grid-cols-2 gap-6 items-center">
                        <motion.div
                            initial="hidden" whileInView="visible" viewport={{ once: true }}
                            variants={fadeUp}
                            className="flex justify-center"
                        >
                            <Image
                                src={s3Static + "blog/living/aircon-service-provider-animated.jpg"}
                                height={280}
                                width={280}
                                placeholder="blur"
                                blurDataURL={s3Static + "placeholder.png"}
                                alt="StringsSG Aircon Service Provider Jobs"
                                className="rounded-3xl"
                            />
                        </motion.div>
                        <div className="space-y-4">
                            {[
                                { icon: <FaPercent className="text-orange-500" />, title: 'New Sign Up Discount', desc: 'Up to 20% off your first aircon service booking.' },
                                { icon: <FaGift className="text-orange-500" />, title: 'Loyalty Reward Points', desc: 'Earn points redeemable for NTUC FairPrice & Grab vouchers.' },
                                { icon: <FaUsers className="text-orange-500" />, title: 'Referral Rewards', desc: 'Refer friends & family and earn rewards on every successful referral.' },
                            ].map((reward, i) => (
                                <motion.div
                                    key={reward.title}
                                    custom={i}
                                    initial="hidden" whileInView="visible" viewport={{ once: true }}
                                    variants={fadeUp}
                                    className="group flex items-start gap-4 bg-white rounded-2xl p-5 border border-gray-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300"
                                >
                                    <div className="flex items-center justify-center w-11 h-11 rounded-xl bg-orange-50 border border-orange-100 shrink-0 group-hover:bg-orange-100 transition-colors">
                                        {reward.icon}
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-gray-900 group-hover:text-orange-600 transition-colors text-sm md:text-base">{reward.title}</h3>
                                        <p className="text-sm text-gray-500 mt-0.5">{reward.desc}</p>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </section> */}

            {/* <SecurePayment />                             */}
            <AirconBrandsWeSupport />            

            {/* ─── Service localities: feeds internal links to /locality/* pages ─── */}
            <AcServiceLocality localityList={countryList.find(c => c.country_cd === 'sg')?.localityList ?? []} />

            {/* ─── Singapore Regulations ───
                Kept for E-E-A-T (no competitor cites the regulatory framework),
                but trimmed: the NEA 3-month / BCA yearly guidance is already
                covered by the "How often should I service my aircon" FAQ below. */}
            <section className="py-6 md:py-10">
                <div className="max-w-4xl mx-auto px-4">
                    <div className="bg-white rounded-2xl border border-gray-100 p-5 md:p-6">
                        <div className="flex items-center gap-2.5 mb-3">
                            <HiShieldCheck className="text-orange-500 text-xl shrink-0" />
                            <h2 className="text-lg md:text-xl font-extrabold text-gray-900 tracking-tight">
                                Singapore Regulations on Air Conditioning Systems
                            </h2>
                        </div>
                        <div className="space-y-2.5 text-sm text-gray-600 leading-relaxed">
                            <p>
                                Air conditioning in Singapore is governed by the National Environment Agency (NEA) and the
                                Building and Construction Authority (BCA), including Air-Conditioning and Mechanical
                                Ventilation (ACMV) requirements under the Building Control Act and the Environmental
                                Public Health Act. These apply to both residential and commercial systems.
                            </p>
                            <p>
                                Aircon servicing should be carried out by trained technicians working for a properly
                                registered contractor. StringsSG Pte Ltd is registered in Singapore under UEN 201813375G,
                                and every aircon job follows the service steps and quality standards StringsSG defines, carried out by vetted technicians from licensed, ACRA-registered contractors.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </RequestProvider>

        {/* ─── Guides: the hub's link into the aircon topic clusters ─── */}
        <AirconGuides />

        {/* ─── FAQs ─── */}
        <section className="max-w-5xl mx-auto px-4 pb-10" aria-label="Frequently Asked Questions">     
            <Faq questionsAnswers={acSingaporeFaqs} title="Aircon Servicing FAQs" />
        </section>                

        {isLoading && <LoadingCover />}           
        {isShowJobScope &&
            <AnimatePresence>
                <AirconScope 
                    setIsShowJobScope={setIsShowJobScope}
                    serviceType={serviceType} 
                    unit={unit} 
                    unitType={unitType} 
                    cost={cost}
                />
            </AnimatePresence>
        }        
        <AnimatePresence>
            {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError} />}
        </AnimatePresence>
    </>
  )
}
